export default __webpack_public_path__ + "static/media/gasag_m1.d9a9e556.png";